import e from "react";
import { getIconColor as c } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const i = {
  display: "block"
}, v = ({ size: o = 16, useVw: r, useRem: t, color: n, withColor: a, removeClassName: d, disableSSR: m, style: l, ...p }) => {
  const f = l ? { ...i, ...l } : i;
  return /* @__PURE__ */ e.createElement(x, { disableSSR: m }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "more-24px", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: r ? ((o || 0) / 375 * 100).toFixed(5) + "vw" : o + (t ? "rem" : "px"), height: r ? ((o || 0) / 375 * 100).toFixed(5) + "vw" : o + (t ? "rem" : "px"), className: d ? "" : "iconpark-icon", style: f, fill: "none", ...p }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: a ? c(n, 0, "currentColor") : "currentColor",
      datafollowfill: a ? c(n, 0, "currentColor") : "currentColor",
      d: "M6.888 0A6.888 6.888 0 0 0 0 6.888v10.224A6.888 6.888 0 0 0 6.888 24h10.224A6.888 6.888 0 0 0 24 17.113V6.888A6.888 6.888 0 0 0 17.113 0H6.888Zm-.892 14.004a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm6 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm8-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
      clipRule: "evenodd",
      fillRule: "evenodd"
    }
  )));
}, C = v;
export {
  C as default
};
